import { render } from "./ItemAIHistory.vue?vue&type=template&id=43b4825e&scoped=true"
import script from "./ItemAIHistory.vue?vue&type=script&lang=js"
export * from "./ItemAIHistory.vue?vue&type=script&lang=js"

import "./ItemAIHistory.vue?vue&type=style&index=0&id=43b4825e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b4825e"]])

export default __exports__